<div class="dialog-title d-flex justify-content-between" #dragRef="cdkDrag" cdkDrag
	cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle [cdkDragConstrainPosition]="dragPositionHandler"
	(mousedown)="handleActiveView()" (mouseup)="dragging = false">
	<h2 mat-dialog-title class="name pb-15px">{{ filename }}</h2>
	<div class="actions d-flex">
		<button type="button" mat-icon-button tabindex="0" class="icon open-icon mat-button-reset"
			matTooltip="បើកក្នុងផ្ទាំងថ្មី" (click)="onOpenInNewWindow()"><mat-icon>open_in_new</mat-icon></button>
		<button color="error" mat-icon-button tabindex="0" class="icon close-icon mat-button-reset"
			matTooltip="បិទ" mat-dialog-close><mat-icon>close</mat-icon></button>
	</div>
</div>

<mat-dialog-content class="file-content">
	<iframe class="main" [class.pe-none]="dragging" [src]="url" frameborder="0" [name]="this.filename"></iframe>

	<div *ngIf="isImage" class="download-btn">
		<button type="button" mat-button class="m-button-download sm" (click)="onDownload()">
			{{ "button.download" | translate }} <mat-icon>cloud_download</mat-icon>
		</button>
	</div>
</mat-dialog-content>
